import { configureStore } from "@reduxjs/toolkit";
import { subAdminSlice } from "Slices/rollManager/subAdmin.slice";
import authReducer from './authSlice';
import travelLocationReducer from "./travel.slice";
import notificationReducer from './notification.slice';
import folderReducer from './imageGallery/folder.slice';
import uploadImageReducer from './imageGallery/uploadImage.slice';
import videoReducer from './youtubeVideo.slice';
import eventReducer from './events.slice';
import trekReducer from './trek.slice';
import enquiryReducer from './enquiry.slice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        travel: travelLocationReducer,
        notifications: notificationReducer,
        folders: folderReducer,
        uploadImage: uploadImageReducer,
        video: videoReducer,
        events: eventReducer,
        trek: trekReducer,
        enquiry: enquiryReducer,
        [subAdminSlice.reducerPath]: subAdminSlice.reducer, 
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(subAdminSlice.middleware),
});
